// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1yqkV","info":"PatientInfo_info__28Cvo"};